import { render, staticRenderFns } from "./recordAdd.vue?vue&type=template&id=bfd077d6&scoped=true&"
import script from "./recordAdd.vue?vue&type=script&lang=js&"
export * from "./recordAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd077d6",
  null
  
)

export default component.exports